import { render, staticRenderFns } from "./ProductRelevance.vue?vue&type=template&id=3395e72f&"
import script from "./ProductRelevance.vue?vue&type=script&lang=ts&"
export * from "./ProductRelevance.vue?vue&type=script&lang=ts&"
import style0 from "./ProductRelevance.vue?vue&type=style&index=0&id=3395e72f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports